import { LitElement, html, css, unsafeCSS } from 'lit';
import classnames from 'classnames';

import config from '../../../shared/config/config';

import likeIcon from './images/like.svg';

import styles from './app-details.component.scss';


class AppDetails extends LitElement {
  static properties = {
    name: { type: String },
    description: { type: String },
    iconSrc: { type: String },
    iconSrcSet: { type: String },
    url: { type: String },
    rating: { type: Number },
    platforms: { type: String },
  }

  static styles = css`${unsafeCSS(styles.toString())}`;

  firstUpdated() {
    const icon = this.renderRoot.querySelector('.app-details__icon');
    icon.onload = () => {
      icon.classList.remove('app-details__icon_loading');
    };
  }

  updated(prevProps) {
    if (!prevProps.get('iconSrc')) return;

    this.renderRoot.querySelector('.app-details__icon').classList.add('app-details__icon_loading');
  }

  render() {
    const iconClass = classnames('app-details__icon', {
      'app-details__icon_mobile': this.platforms.includes('iOS') && !this.platforms.includes('Mac'),
    });

    return html`
      <a class="app-details" href=${this.url}>
        <img
          loading="lazy"
          class=${iconClass}
          src="${this.iconSrc}"
          srcset="${this.iconSrcSet}"
          alt="${this.name}"
          width="80"
          height="80"
        />
        <div>
          <div class="app-details__title">${this.name}</div>
          <div class="app-details__description">${this.description}</div>
          <div class="app-details__short-info">
            ${this.rating ? html`
              <img src="${likeIcon}" alt="" width=16 height=16>
              <div class="app-details__rating">${this.rating}%</div>
            ` : undefined}
            <div>${this.platforms}</div>
          </div>
        </div>
      </a>
    `;
  }
}

const defineAppDetailsElement = () => {
  customElements.define(config.get('customElements').appDetails, AppDetails);
};

export default defineAppDetailsElement;
